import {
  coordinatesOnTheFloor,
  nikeaCoordinatesOnTheFloor,
} from "../Data/ApartmentsTypes";
import { setDrawerIsOpen } from "../store/drawerSlice";

export const getApartmentTypeByIds = (
  typeId,
  subTypeId,
  ApartmentsTypes,
  selectedProject
) => {
  const apartmentTypeObject = ApartmentsTypes[
    selectedProject.name
  ].apartmentsArray.find((type) => type.id === typeId);

  const apartmentSubTypeObject = apartmentTypeObject.subType.find(
    (subType) => subType.id === subTypeId
  );
  // if (
  //   apartmentTypeObject === undefined ||
  //   apartmentSubTypeObject === undefined
  // ) {
  //   console.log(
  //     "apartmentTypeObject =>",
  //     selectedProject.name,
  //     apartmentTypeObject,
  //     typeId
  //   );
  //   console.log(
  //     "apartmentSubTypeObject => ",
  //     apartmentSubTypeObject,
  //     subTypeId
  //   );
  // }

  return { apartmentTypeObject, apartmentSubTypeObject };
};

export const getCoordinatesObjById = (id, project, floorId) => {
  if (project === "greenhome") {
    return coordinatesOnTheFloor.find((item) => item.id === id);
  } else if (project === "nikea") {
    const coordinatesOnTheFloorObject = nikeaCoordinatesOnTheFloor.find(
      (item) => item.floorIds.includes(Number(floorId))
    );

    if (coordinatesOnTheFloorObject) {
      // console.log(
      //   "coordinatesOnTheFloorObject => ",
      //   coordinatesOnTheFloorObject.apartmentsPaths
      // );
      return coordinatesOnTheFloorObject.apartmentsPaths.find(
        (item) => item.id === id
      );
    }
  }
};

export const delayNavigation = (dispatch, navigate, path, event) => {
  if (event) {
    event.preventDefault();
  }
  dispatch(setDrawerIsOpen(true));

  setTimeout(() => {
    navigate(path);
  }, 2000);
};
